export const en = {
  // Pricing 2026 plan features
  basicHeader: 'Includes:',
  aiAgentIntegrations: 'AI Agent integrations via MCP',
  feedbackOnSitesAndFiles: 'Feedback on Websites, Figma, PDFs & images',
  screenshotsMetadata: 'Capture screenshots & technical metadata',
  textEditsAndVideo: 'Text edit suggestions and video feedback',
  collaborationIntegrations: 'Slack, Teams, Zapier and Make integrations',
  proHeader: 'Includes Basic features, plus:',
  twoWayIntegrations:
    '2-way integrations with Jira, Asana, ClickUp, Monday, and more',
  clientCollaborationSection: 'Client collaboration such as:',
  privateTeamComments: 'Private team commenting',
  clientPortal: 'Client-facing project portal',
  aiAssistedProductivity:
    'AI assisted productivity features like Similar Feedback detection, auto-tagging & title generation',
  apiAccess: 'API access',

  // Standard plan features
  standardHeaderA: 'All plans include:',
  unlimitedGuests: 'Unlimited Client users',
  unlimitedProjects: 'Unlimited Projects',
  membersStandard: '5 Team Members (Members = your internal team)',
  standardHeaderB: 'What you get:',
  websiteFeedback: 'In-context feedback on staging and live websites',
  designFeedback: 'Visual feedback on Figma designs, PDFs, images',
  screenshots: 'Automatic screenshots with complete technical details',
  integrationsStandard: 'Connect with Trello, Slack, GitHub + 12 more tools)',
  publicFeedback: 'Public Feedback Widget',
  videoFeedback: 'Video Feedback',
  storage10: '10GB storage for Projects',

  // Studio plan features
  studioHeader: 'Everything in Standard, plus:',
  plusStandard: 'Plus everything on Standard',
  membersStudio: 'More team capacity with 10 Team Members',
  storage25: 'Increased storage (25GB storage for Projects)',

  // Premium plan features
  premiumHeader: 'Everything in Studio, plus:',
  membersComment: 'Member-only comments for internal discussions',
  customBranding: 'Add your own custom branding',
  clientProjectBoard: 'Client project board (Give clients their own project view)',
  guestsSeeGuests: 'Clients can see other clients feedback',
  premiumIntegrations:
    'Premium integrations including Jira, Asana, Linear, ClickUp, and Monday.com ',
  storage50: 'Increased storage (50GB)',
  scheduledFeedbackDeadlines: 'Scheduled feedback deadlines',
  projectFolders: 'Organize Projects into Folders',

  // Deluxe plan features
  deluxeHeader: 'Everything in Premium, plus:',
  storage150: 'Increased storage (150GB)',
  plusEverythingOnPremium: 'Plus everything on Premium',

  // Freemium
  creditCardRequired:
    "You'll need to enter payment details. Don't worry we won't charge your card for the free plan.",

  // Custom plan features
  customFeaturesHeaderVariant: 'Everything in Pro, plus:',
  customFeaturesHeader: 'Everything in Premium, plus:',
  customMemberLimit: 'Custom member limit',
  dedicatedSuccessManager: 'Dedicated Success Manager',
  onboardingAndTraining: 'Onboarding & training support',
  upltimeSla: '99.9% uptime SLA',
  plusPremium: 'Plus everything on Premium',
  singleSignOn: 'Secure single sign-on (SSO)',

  twoMonthsFree: 'Incl. 2 Months Free',
  threeMonthsFree: 'Incl. 3 Months Free',

  // Plan descriptions
  descriptionStandard: 'For freelancers and small teams with a few client sites.',
  descriptionStudio: 'For growing agencies managing multiple client sites.',
  descriptionPremium:
    'For established agencies needing custom workflows and advanced integrations.',
  descriptionDeluxe:
    'For large teams with complex workflows and dedicated support requirements.',
  descriptionBasic:
    'Everything you need to collect, track, and resolve website feedback in one place.',
  descriptionPro:
    'For teams looking to automate website QA and level-up the client feedback experience.',
  descriptionCustom:
    'For larger teams looking to efficiently scale the QA and client review process.'
};

export type ColumnPlanTranslations = typeof en;
